import { useSearchParams } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { AccountSection } from "@/components/settings/AccountSection";
import { AppearanceSection } from "@/components/settings/AppearanceSection";
import { PreferencesSection } from "@/components/settings/PreferencesSection";
import { PersonalizationSection } from "@/components/settings/PersonalizationSection";
import { UsageSection } from "@/components/settings/UsageSection";
import { SecuritySection } from "@/components/settings/SecuritySection";
import { useMe } from "@/hooks/queries";

const TABS = [
  { key: "account", label: "Account", Component: AccountSection },
  { key: "appearance", label: "Appearance", Component: AppearanceSection },
  { key: "preferences", label: "Preferences", Component: PreferencesSection },
  { key: "about", label: "About you", Component: PersonalizationSection },
  { key: "usage", label: "Usage", Component: UsageSection },
  { key: "security", label: "Security", Component: SecuritySection },
];

export default function SettingsPage() {
  const [params, setParams] = useSearchParams();
  const tab = TABS.some((t) => t.key === params.get("tab")) ? params.get("tab") : "account";
  const { data: me, isLoading } = useMe();

  return (
    <div className="h-full overflow-y-auto" data-testid="settings-page">
      <div className="mx-auto w-full max-w-[920px] px-4 pb-16 pt-8 sm:px-6 sm:pt-12">
        <h1 className="text-[1.7rem] font-semibold tracking-tight text-white sm:text-3xl">Settings</h1>
        <Tabs value={tab} onValueChange={(v) => setParams({ tab: v }, { replace: true })} orientation="vertical" className="mt-8 flex flex-col gap-6 md:flex-row md:gap-10">
          <TabsList className="flex h-auto w-full shrink-0 justify-start gap-1 overflow-x-auto bg-transparent p-0 md:w-48 md:flex-col md:items-stretch">
            {TABS.map((t) => (
              <TabsTrigger
                key={t.key}
                value={t.key}
                data-testid={`settings-tab-${t.key}`}
                className="justify-start rounded-lg px-3 py-2 text-[14px] text-zinc-400 transition-colors hover:text-zinc-100 data-[state=active]:bg-white/[0.07] data-[state=active]:text-white data-[state=active]:shadow-none"
              >
                {t.label}
              </TabsTrigger>
            ))}
          </TabsList>
          <div className="min-w-0 flex-1">
            {isLoading || !me ? (
              <div className="h-48 animate-pulse rounded-xl bg-white/[0.04]" />
            ) : (
              TABS.map(({ key, Component }) => (
                <TabsContent key={key} value={key} className="mt-0" data-testid={`settings-panel-${key}`}>
                  <Component me={me} />
                </TabsContent>
              ))
            )}
          </div>
        </Tabs>
      </div>
    </div>
  );
}
